// Test IDs for the auth feature (login, register, password reset, logout).
// Add new keys here as you wire up additional auth UI; see ./index.js for
// the recipe to add a new feature file.
//
// Directive:
//   - Keys are camelCase, values are kebab-case shaped as `<feature>-<element>`
//     (or `<feature>-<element>-<qualifier>` when an element repeats). Examples:
//     'login-submit-button', 'cart-quantity-input', 'product-card-image'.
//   - Reference them in JSX as `data-testid={LOGIN.submitButton}`.
//
// Why kebab-case values: required by qabot's CSS-attribute selector matcher
// and the lint rule `emergent(kebab-case-testid)`.

export const LOGIN = {
	emailInput: 'login-email-input',
	identifierInput: 'login-identifier-input',
	passwordInput: 'login-password-input',
	otpCodeInput: 'login-otp-code-input',
	forgotPasswordLink: 'login-forgot-password-link',
	sendOtpButton: 'login-send-otp-button',
	verifyOtpButton: 'login-verify-otp-button',
	submitButton: 'login-submit-button',
	otpModeSwitchLink: 'login-switch-to-otp-link',
	passwordModeSwitchLink: 'login-switch-to-password-link',
	resendOtpButton: 'login-resend-otp-button',
	registerLink: 'login-register-link',
	applicationPending: 'login-application-pending',
};

export const REGISTER = {
	firstNameInput: 'register-first-name-input',
	lastNameInput: 'register-last-name-input',
	nameInput: 'register-name-input',
	emailInput: 'register-email-input',
	phoneInput: 'register-phone-input',
	passwordInput: 'register-password-input',
	passwordConfirmInput: 'register-password-confirm-input',
	submitButton: 'register-submit-button',
	stateInput: 'register-state-input',
	cityInput: 'register-city-input',
	termsCheckbox: 'register-terms-checkbox',
	loginLink: 'register-login-link',
	verifyButton: 'register-verify-button',
	inlineCodeInput: 'register-inline-code-input',
	verifyCodeButton: 'register-verify-code-button',
	verifiedMarker: 'register-verified-marker',
	alreadyRegistered: 'register-already-registered',
	applicationPending: 'register-application-pending',
	referredByInput: 'register-referred-by-input',
	referredByLocked: 'register-referred-by-locked',
};

export const PHONE_GATE = {
	dialog: 'phone-gate-dialog',
	phoneInput: 'phone-gate-phone-input',
	codeInput: 'phone-gate-code-input',
	sendButton: 'phone-gate-send-button',
	verifyButton: 'phone-gate-verify-button',
	resendButton: 'phone-gate-resend-button',
	continueButton: 'phone-gate-continue-button',
	signOutButton: 'phone-gate-sign-out-button',
};

export const LOGOUT = {
	button: 'logout-button',
};
